export default __webpack_public_path__ + "static/media/AppLogo.439732cb.svg";